module.exports = __webpack_public_path__ + "img/banner-34.61156fc9.jpg";